import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import * as ac from "./action-creators";
import type { CompanyAnalysisContactsState } from "./initial-state";
import initialState from "./initial-state";

const companyAnalysisContactsReducer = createReducer<CompanyAnalysisContactsState, ActionType<typeof ac>>(initialState)
    .handleAction(
        ac.employeeLocationIdsSelectedAction,
        (state, { payload }): CompanyAnalysisContactsState => ({
            ...state,
            selectedEmployeeLocationIds: payload,
        }),
    )
    .handleAction(
        ac.profileModalIsOpenedSetAction,
        (state, { payload }): CompanyAnalysisContactsState => ({
            ...state,
            isProfileModalOpened: payload,
        }),
    )
    .handleAction(
        ac.setProfileForEditAction,
        (state, { payload }): CompanyAnalysisContactsState => ({
            ...state,
            profileForEdit: payload,
            isProfileModalOpened: !!payload,
        }),
    )
    .handleAction(
        ac.profileSelectedAction,
        (state, { payload }): CompanyAnalysisContactsState => ({
            ...state,
            selectedProfileId: payload,
        }),
    )
    .handleAction(
        ac.contactDetailsSelectedAction,
        (state, { payload }): CompanyAnalysisContactsState => ({
            ...state,
            contactDetails: payload,
        }),
    )
    .handleAction(
        ac.contactsTableSortByChangedAction,
        (state, { payload }): CompanyAnalysisContactsState => ({
            ...state,
            sortBy: payload,
        }),
    )
    .handleAction(
        ac.contactsTableFiltersChangedAction,
        (state, { payload }): CompanyAnalysisContactsState => ({
            ...state,
            tableSearchText: payload.searchText ?? state.tableSearchText,
            tableCurrentPage: payload.page ?? state.tableCurrentPage,
        }),
    );

export default companyAnalysisContactsReducer;
